import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: '', redirectTo: 'front', pathMatch: 'prefix' },
    { path: 'login', loadComponent: () => import('./pages/login/login.component').then(e => e.LoginComponent) },
    { path: 'forget', loadComponent: () => import('./pages/forget-password/forget-password.component').then(e => e.ForgetPasswordComponent) },
    { path: 'register', loadComponent: () => import('./pages/register/register.component').then(e => e.RegisterComponent) },
    { path: 'front', loadChildren: () => import('./layout//front/front-routing') },
    { path: 'not-found-404', loadComponent: () => import('./pages/not-found-404/not-found-404.component').then(e => e.NotFound404Component) },
    { path: '**', redirectTo: 'not-found-404' }
];
